<template>
  <div class="tt-gift-faq">
    <div class="tt-gift-faq__questions"
         v-for="(question, index) in questions"
         :key="index">
      <Dropdown>
        <template v-slot:label>
          <div class="tt-gift-faq__question">
            {{ $t(question.question) }}
          </div>
        </template>
        <template v-slot:content>
          <div class="tt-gift-faq__answer"
               v-html="$t(question.answer)"></div>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/shared/Dropdown.vue";

export default {
  data: () => ({
    questions: []
  }),
  components: {Dropdown}
}
</script>

<style lang="sass" scoped>
@import "src/assets/styles-new/typography"
@import "src/assets/styles-new/vars"

.tt-gift-faq
  &__title
    font-size: $fs-larger
    font-weight: $fw-semibold
    margin-bottom: 48px


@media screen and (max-width: $tablet-width)
  .tt-gift-faq
    &__title
      font-size: $fs-large
      margin-bottom: 40px

@media screen and (max-width: $mobile-width)
  .tt-gift-faq
    &__title
      font-size: $fs-semilarge
      margin-bottom: 28px
    &__question
      font-size: 1rem
    &__answer
      font-size: $fs-small

</style>